export default {
  "landing-page": () => import("/usr/src/apps/finq-ai/src/layouts/landing.page.vue"),
  blank: () => import("/usr/src/apps/base/src/layouts/blank.vue"),
  default: () => import("/usr/src/apps/base/src/layouts/default.vue")
}